module.exports = __webpack_public_path__ + "img/predicciones_isack.51d8dc56.png";